var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconEyeOn(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 15,
    viewBox: "0 0 24 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1355_13938)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.453 6.07477C21.8511 4.24649 17.5334 0 12.0009 0C6.46842 0 2.1508 4.24649 0.548819 6.07477C-0.177731 6.89836 -0.177731 8.10163 0.548819 8.92523C2.1508 10.7535 6.47438 15 12.0069 15C14.7702 15 17.2357 13.9369 19.2069 12.646C21.1781 11.3551 22.655 9.83645 23.459 8.92523C24.1855 8.10163 24.1855 6.89836 23.459 6.07477H23.453ZM12.0009 12.2255C9.34485 12.2255 7.18306 10.1051 7.18306 7.5C7.18306 4.89486 9.34485 2.77453 12.0009 2.77453C14.657 2.77453 16.8188 4.89486 16.8188 7.5C16.8188 10.1051 14.657 12.2255 12.0009 12.2255Z",
    fill: "#16BAB6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.0009 10.7647C13.8395 10.7647 15.3299 9.30288 15.3299 7.49956C15.3299 5.69625 13.8395 4.23438 12.0009 4.23438C10.1623 4.23438 8.67188 5.69625 8.67188 7.49956C8.67188 9.30288 10.1623 10.7647 12.0009 10.7647Z",
    fill: "#16BAB6"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1355_13938"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 15,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEyeOn);
export default __webpack_public_path__ + "static/media/icon_eye_on.ef231aa3.svg";
export { ForwardRef as ReactComponent };